module.exports = __webpack_public_path__ + "media/begin.2772e4d4.mp3";